<main class="root">
  <!-- Skip to content link for accessibility -->
  <button
    class="skip-to-content"
    (click)="skipToContent()"
    aria-label="Direkt zum Archiv springen"
    type="button"
  >
    Direkt zum Inhalt
  </button>

  <app-timeout-dialog></app-timeout-dialog>
  <div class="loader-line" *ngIf="archiveService.loading"></div>
  <app-header
    [eternalPage]="archiveService.eternalPage"
    [resultPage]="false"
    [loading]="archiveService.loading"
    [loanFilterData]="archiveService.dataLoan"
    [filterDataOptions]="archiveService.dataFilterOptions"
    [offersData]="archiveService.dataOffers"
    [twoApplicants]="false"
  >
  </app-header>
  <section class="resultpage" *ngIf="archiveService.showDataOffers">
    <app-filter
      [filterData]="archiveService.dataFilter"
      [filterOptionsData]="archiveService.dataFilterOptions"
      [offersData]="archiveService.dataOffers"
      (filterOutput)="postFilter()"
      [eternalPage]="archiveService.eternalPage"
      [resultPage]="false"
      [loanRequestError]="false"
      [loanRequestErrorMessage]="''"
    ></app-filter>
    <div class="resultpage_inner-container">
      <ng-container *ngIf="+windowCouponAmount > 0">
        <app-coupon-panel></app-coupon-panel>
      </ng-container>
      <app-offer
        [loanFilterData]="archiveService.dataLoan"
        [filterDataOptions]="archiveService.dataFilterOptions"
        [offersData]="archiveService.dataOffers"
        [noOffersData]="archiveService.dataNoOffers"
        [time]="0"
        [showDefaultPlaceholders]="false"
        (filterOutput)="postFilter()"
        [eternalPage]="archiveService.eternalPage"
        [resultPage]="false"
        [twoApplicants]="false"
        [apptrackToken]="''"
        [pageType]="'archive'"
      ></app-offer>
    </div>
  </section>
  <app-track-conversion-funnel></app-track-conversion-funnel>
</main>
<div
  class="nooffers"
  *ngIf="archiveService.eternalPage && !archiveService.showDataOffers"
>
  <h1 class="nooffers__title">Keine abgelaufene Kredite</h1>
  <p class="nooffers__text">
    Aktuell befinden sich keine abgelaufenen Kredite in Ihrem Kreditcenter
  </p>
  <a class="nooffers__link" href="https://www.check24.at/kredit"
    >jetzt Kredite vergleichen</a
  >
</div>
